<section class="content">
  <div class="container-fluid">
    <div class="row">
      <div class="row mt-3">
        <div class="container py-5">
          <div class="card shadow-sm">
            <div class="card-header bg-primary text-white">
              <h3 class="mb-0">Invoice Entry</h3> <span
              class="text-end font-weight-bolder">Lovely Fashion, Madurai</span>
            </div>
            <div class="card-body">
              <form class="needs-validation" [formGroup]="invoiceFormGroup" (submit)="onSubmit()">
                <div class="row mb-4">
                  <div class="col-md-8">
                    <h5 class="mb-3">Customer Information</h5>
                  </div>
                  <div class="col-md-4 justify-content-end">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="billType" id="inlineRadio1"
                             formControlName="billType" value="OFFLINE">
                      <label class="form-check-label" for="inlineRadio1">Shop</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="billType" id="inlineRadio2"
                             formControlName="billType" value="ONLINE">
                      <label class="form-check-label" for="inlineRadio2">Online</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-3 mb-3">
                    <label class="form-label">Full Name</label>
                    <input type="text" class="form-control" formControlName="customerName">
                    <span class="text-danger" *ngIf="invoiceErrors.customerName">{{ invoiceErrors.customerName }}</span>
                  </div>
                  <div class="col-md-3 mb-3">
                    <label class="form-label">Phone Number</label>
                    <input type="tel" class="form-control" formControlName="phoneNumber" maxlength="10" (keypress)="allowOnlyNumbers($event)">
                    <span class="text-danger" *ngIf="invoiceErrors.phoneNumber">{{ invoiceErrors.phoneNumber }}</span>
                  </div>
                  <div class="col-md-3 mb-3">
                    <label class="form-label">Invoice Date</label>
                    <input type="date" class="form-control" formControlName="invoiceDate">
                  </div>
                  <div class="col-md-3 mb-3">
                    <label class="form-label" *ngIf="isOffline">Order Via</label>
                    <select class="form-select" id="floatingSelect" aria-label="Floating label select example" formControlName="orderVia" *ngIf="isOffline">
                      <option [value]="" disabled>Select Order Via</option>
                      <option *ngFor="let option of options" [value]="option.value">
                        {{ option.label }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4 col-lg-2 mb-3">
                    <label class="form-label">Door No</label>
                    <input type="text" class="form-control" formControlName="doorNo">
                  </div>
                  <div class="col-md-4 col-lg-4 mb-3">
                    <label class="form-label">Street Name & Area</label>
                    <input type="text" class="form-control" formControlName="street">
                  </div>
                  <div class="col-md-4 col-lg-2 mb-3">
                    <label class="form-label">City</label>
                    <input type="text" class="form-control" formControlName="city">
                  </div>
                  <div class="col-md-4 col-lg-2 mb-3">
                    <label class="form-label">State</label>
                    <select class="form-select" formControlName="state">
                      <option value="" selected disabled>Select State</option>
                      <option *ngFor="let state of states" [value]="state">{{ state }}</option>
                    </select>
                  </div>
                  <div class="col-md-4 col-lg-2 mb-3">
                    <label class="form-label">Pincode</label>
                    <input type="text" class="form-control" formControlName="pincode" maxlength="6" (keypress)="allowOnlyNumbers($event)">
                  </div>
                </div>

                <h5 class="mb-3">Item Details</h5>
                <div class="table-responsive mb-4">
                  <table class="table table-bordered" id="itemTable">
                    <thead class="table-light text-center">
                    <tr>
                      <th>Product Code</th>
                      <th class="col-3">Product Name</th>
                      <th class="col-2">Size</th>
                      <th>Quantity</th>
                      <th>Unit Price</th>
                      <th>Total</th>
                      <th>Action</th>
                    </tr>
                    </thead>
                    <tbody formArrayName="products">
                    <tr *ngFor="let item of products.controls; let i = index" [formGroupName]="i">
                      <td>
                        <input type="text" class="form-control" formControlName="productCode" (input)="getAllProductsByProductCode(i)"></td>
                      <td>
                        <select class="form-select" formControlName="productName" (change)="productBasedSize($event, i)">
                          <option value="" disabled selected>Product</option>
                          <option *ngFor="let product of productList[i] || []"
                                  [value]="product.productName + '|' + product.productId">{{ product.productName }}</option>
                        </select>
                      <td>
                        <select class="form-select" formControlName="size" (input)="getSizeBasedPrice($event, i)">
                          <option value="" disabled selected>Size</option>
                          <option *ngFor="let product of productVariants[i] || []"
                                  [value]="product.size + '|' + product.productVariantId">{{ product.size }}</option>
                        </select>
                      </td>
                      <td><input type="number" class="form-control" formControlName="quantity"></td>
                      <td><input type="number" class="form-control" formControlName="unitPrice"></td>
                      <td><input type="number" class="form-control" formControlName="totalPrice" readonly></td>
                      <td>
                        <button type="button" class="btn btn-danger btn-sm" (click)="removeItem(i)">Remove</button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <button type="button" class="btn btn-secondary mb-3"
                          (click)="addItem(this.customerEnquiry.productDetails)">Add New Item
                  </button>
                </div>

                <div class="row justify-content-end">
                  <div class="col-md-4">
                    <div class="card bg-light">
                      <div class="card-body">
                        <div class="mb-3">
                          <label class="form-label">Subtotal</label>
                          <input type="number" class="form-control" id="subtotal" formControlName="subTotal" readonly>
                        </div>
                        <!--<div class="mb-3">
                          <label class="form-label">Tax Rate (%)</label>
                          <select class="form-select" >
                            <option value="0">0%</option>
                            <option value="5">5%</option>
                            <option value="10">10%</option>
                            <option value="15">15%</option>
                          </select>
                        </div>
                        <div class="mb-3">
                          <label class="form-label">Tax Amount</label>
                          <input type="number" class="form-control" id="taxAmount" readonly>
                        </div>-->
                        <div class="mb-3">
                          <label class="form-label">Discount(In Amount)</label>
                          <input type="number" class="form-control" formControlName="discount">
                        </div>
                        <div class="mb-3">
                          <label class="form-label">Total Amount</label>
                          <input type="number" class="form-control" id="totalAmount" formControlName="totalAmount"
                                 readonly>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mt-4 text-end">
                  <button type="reset" class="btn btn-secondary me-2">Reset</button>
                  <button type="submit" class="btn btn-primary">Submit Invoice</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
